import {AP_MODAL_ADD_COMPONENT, AP_MODAL_SET_STATUS} from '../types/appModalTypes';

export default function (state = null, action) {
    const { type, payload } = action;

    switch (type) {
        case AP_MODAL_ADD_COMPONENT:
            return { ...state,
                [payload.name]:payload
            };

        case AP_MODAL_SET_STATUS:
            return {...state,
                [payload.name]: {...state[payload.name], ...payload}
            };

        default:
            return state;
    }
}